import { storeToRefs } from "pinia";
import { ref, unref, watch } from "vue";

import { getHotelsAsync } from "@/api/biz/openHotel";
import { useUserStoreHook } from "@/store/modules/user";

export function useHotels({
  infinite = false,
  pageSize = 10,
  stay,
  filter,
  preferred
}) {
  const userStore = useUserStoreHook();
  const { languageISO639Style } = storeToRefs(userStore);
  const loading = ref(false);
  const hotels = ref([]);
  const pagination = ref({
    total: 0,
    pageSize,
    currentPage: 1
  });

  const _getHotels = async () => {
    if (loading.value) {
      return;
    }
    loading.value = true;
    const params = {
      preferred: unref(preferred),
      stay: unref(stay),
      filter: unref(filter),
      paging: {
        limit: pagination.value.pageSize,
        skip: pagination.value.pageSize * (pagination.value.currentPage - 1)
      }
    };
    params.preferred.language = languageISO639Style.value;
    getHotelsAsync(params, res => {
      let hotelsData = null;
      hotelsData = res.hotels;
      if (hotelsData) {
        if (res.asyncJobId) {
          hotels.value = hotels.value.concat(hotelsData);
        } else {
          hotels.value = hotels.value.map(h => {
            const asyncItem = hotelsData.find(a => {
              return h._id === a._id;
            });
            if (asyncItem) {
              h = Object.assign(h, asyncItem);
            }
            return h;
          });
          pagination.value.currentPage += 1;
          pagination.value.total = res.paging.count;
        }
        loading.value = false;
      }
    });
  };
  const refreshHotels = () => {
    hotels.value = [];
    pagination.value.currentPage = 1;
    _getHotels();
  };
  const fetchHotels = () => {
    _getHotels();
  };
  watch(
    [stay, filter, preferred, languageISO639Style],
    () => {
      refreshHotels();
    },
    { deep: true }
  );
  return {
    loading,
    pagination,
    hotels,
    refreshHotels,
    fetchHotels
  };
}
